import BonusScreen from './scenes/BonusScreen';
import Game from './scenes/Game';
import ResultsScreen from './scenes/ResultsScreen';
import TitleScreen from './scenes/TitleScreen';

export default {
  /**
     * Add your scene classes here. Simply put the scene class.
     * Ex: `scenes: [MyScene,MyOtherScene]`
     * @type {{KEY:string}[]}
     */
  scenes: [TitleScreen, Game, ResultsScreen, BonusScreen],

  /**
     * Set the first scene that should be loaded here. Must match one of the scenes' key found in the scenes array.
     * It is recommended you put `MyScene.KEY` here instead of using a string.
     * @type {string}
     */
  startScene: TitleScreen.KEY,

  gameInfo: {
    currentRound: 1,
    playedInstructions: false
  },
  userData: {
    /** @type {{round:number, totalCount:number, incorrectCount:number, questionResults:{questionString:string, attempts:number}[]}[]} */
    roundResults: [{ round: 1, totalCount: 0, incorrectCount: 0, questionResults: [] },
      { round: 2, totalCount: 0, incorrectCount: 0, questionResults: [] },
      { round: 3, totalCount: 0, incorrectCount: 0, questionResults: [] }],

    /** @type {{score:number, wrongPops:number[], bonusType:string}} */
    bonusResults: {
      score: 100,
      wrongPops: [],
      bonusType: 'Even'
    }
  },

  fontSizes: {
    sm: 20,
    med: 36,
    lg: 96
  }
};
